import React from 'react'
import FaIcon from '../../Elements/FaIcon';
import StickyNote from '../../Elements/StickyNote';
import CookieHelper from '../../Helpers/cookieHelper';

function InfoBoxForPlanning(props)
{
    let cookiecontent=CookieHelper.getCookie(CookieHelper.CookieNameEnum.ColorInfoBoxPl)
    const [open, setOpen]=React.useState(cookiecontent===""?true:cookiecontent==="true");

    let bgcolors=["Grey","Orange","Yellow","LightGreen","Green","Red"];
    let colors=["White","Black","Black","Black","White","White"];
    let names=["Planned","Assigned","Completed","Finalized","Invoiced","Excluded"];

    let title=(
        <div 
            onClick={()=>{
                setOpen(!open);
                CookieHelper.setCookie(CookieHelper.CookieNameEnum.ColorInfoBoxPl,!open);
                window.infoBoxForPlanningState=(!open).toString();
            }} 
            className="pointer"
        >
            {
                open
                ? 
                    <div className="row">
                        <div className="col text-left bold">
                            Graph colors
                        </div>
                        <div className="col text-right bold">
                            <FaIcon iconName="fa-solid fa-times" innerClassName="text-green"/> 
                        </div>
                    </div>
                :
                    <span className="form-control-xs">
                        Graph
                        <>&nbsp;</>
                        <FaIcon iconName="fa-solid fa-plus" innerClassName="text-green"/> 
                    </span>
            }
            
                
        </div> 
    );
    
    let colordivs=[];
    if(open)
    {
        for(let i=0; i<bgcolors.length; i++)
        {
            colordivs.push(
                <div className="col-4 p-1 " >
                    <div className="text-center bold rounded" style={{backgroundColor: bgcolors[i], color: colors[i]}}>
                        {names[i]}
                    </div>
                </div>
            );
        }
    }

    let content=open
        ?(
            <div className="container bg-lightgray rounded" >
                <div className="row">
                    {colordivs}
                </div>
            </div>
        )
        :null;

    

    return(
        <StickyNote
            title={title}
            text={content}
            rotated="+"
        />
    );
}




export default InfoBoxForPlanning;
